<template>
  <div class="content">
    <div class="thehome">{{ $t("header.home") }} &nbsp;/</div>
    <div class="require">
      (<span style="color: #ed7e64">*</span>)&nbsp;{{
        $t("header.This_field_is_required")
      }}
    </div>
    <div class="inputcontent">
      <!-- <div class="one">GDSC 2025 比赛报名申请</div> -->
      <div class="one">SIGGRAPH DAY 活动报名</div>
      <div class="member_table">
        <div class="inputtype">{{ $t("header.Personal_information") }}</div>
        <div class="row">
          <div class="flex toright">
            <div class="tothetitle">
              {{ $t("header.Personal_information")
              }}<span style="color: #ed7e64">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.name"
                :placeholder="$t('header.name')"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex">
            <!-- Removed contact information field -->
          </div>
        </div>

        <div class="row">
          <div class="flex toright">
            <div class="tothetitle">
              <span>公司/单位</span
              ><span style="color: #ed7e64"
                ><span style="color: #ed7e64">*</span></span
              >
            </div>
            <div class="input">
              <el-input
                v-model="state.company"
                placeholder="公司/单位"
                type="text"
              ></el-input>
            </div>
          </div>
          <div class="flex">
            <!-- Removed contact information field -->
          </div>
        </div>

        <div class="inputtype">
          {{ $t("header.Contact_information")
          }}<span style="color: #ed7e64">*</span>
        </div>
        <div class="row">
          <div class="flex toright tobottom">
            <div class="tothetitle">
              {{ $t("header.telephone") }}<span style="color: #ed7e64">*</span>
            </div>
            <div class="input">
              <el-input
                v-model="state.phone"
                :placeholder="$t('header.telephone')"
                type="text"
                @input="validatePhone"
                :class="state.phoneerror && 'error'"
              ></el-input>
              <div
                v-if="state.phoneerror"
                style="
                  color: #d43327;
                  margin-top: 10px;
                  font-weight: 800;
                  position: absolute;
                "
              >
                请输入正确电话号码格式
              </div>
            </div>
          </div>
          <div class="flex">
            <div class="tothetitle">
              {{ $t("header.email")
              }}<span style="color: #ed7e64">*</span>(确保是本人邮箱)
            </div>
            <div class="input">
              <el-input
                v-model="state.mailbox"
                :placeholder="$t('header.email')"
                type="email"
                @input="email"
                :class="state.emailerror && 'error'"
                :style="
                  state.emailerror && 'border: 2px solid #43327!important;'
                "
              ></el-input>
              <div
                v-if="state.emailerror"
                style="
                  color: #d43327;
                  margin-top: 10px;
                  font-weight: 800;
                  position: absolute;
                "
              >
                请输入正确邮箱
              </div>
            </div>
          </div>
        </div>

        <div
          class="submit"
          @click="submit"
          :class="
            state.name &&
            state.phone &&
            state.mailbox &&
            !state.emailerror &&
            'click'
          "
        >
          <div class="tj">{{ $t("header.submit") }}</div>
          <div class="arrow-icon">
            <img
              src="https://bunseninstitutes.oss-cn-hangzhou.aliyuncs.com/files/images/join_icon_arrow.svg"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ElNotification, ElMessage, ElMessageBox } from "element-plus";
import { application_forms } from "@/api/type.js";
import { reactive } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
const router = useRouter();
const { locale } = useI18n();
const state = reactive({
  name: "",
  phone: "",
  mailbox: "",
  emailerror: false,
  company: "",
  phoneerror: false, // Add phone error state
});

const validatePhone = (value) => {
  // Strict Chinese mobile phone number validation
  const phonePattern = /^1[3-9]\d{9}$/; // Matches 11-digit numbers starting with 13-19

  if (phonePattern.test(value)) {
    state.phoneerror = false;
  } else {
    state.phoneerror = true;
  }
};
const email = (e) => {
  const emailPattern = /^[\w\.-]+@[\w\.-]+\.\w+$/;
  if (emailPattern.test(e)) {
    state.emailerror = false;
  } else {
    state.emailerror = true;
  }
};
const resetForm = () => {
  state.name = "";
  state.phone = "";
  state.company = "";
  state.mailbox = "";
  state.emailerror = false;
  state.phoneerror = false;
};
let isSubmitting = false;
const submit = async () => {
  if (isSubmitting) return; // 阻止重复提交
  isSubmitting = true;
  // 验证所有必填字段
  if (!state.name) {
    ElMessage.error(
      locale.value == "zh" ? "请输入姓名" : "Please enter your name"
    );
    isSubmitting = false;
    return;
  }

  if (!state.company) {
    ElMessage.error(
      locale.value == "zh" ? "请输入公司/单位" : "Please enter your company"
    );
    isSubmitting = false;
    return;
  }

  if (!state.phone) {
    ElMessage.error(
      locale.value == "zh" ? "请输入手机号码" : "Please enter your phone number"
    );
    isSubmitting = false;
    return;
  } else if (state.phoneerror) {
    ElMessage.error(
      locale.value == "zh"
        ? "请输入正确的手机号码"
        : "Please enter a valid phone number"
    );
    isSubmitting = false;
    return;
  }

  if (!state.mailbox) {
    ElMessage.error(
      locale.value == "zh" ? "请输入邮箱" : "Please enter your email"
    );
    isSubmitting = false;
    return;
  } else if (state.emailerror) {
    ElMessage.error(
      locale.value == "zh"
        ? "请输入正确的邮箱格式"
        : "Please enter a valid email"
    );
    isSubmitting = false;
    return;
  }

  try {
    const result = await application_forms({
      username: state.name,
      work_unit: state.company,
      phone: state.phone,
      email: state.mailbox,
    });

    // console.log(result, 84934);

    // 处理递增数字返回值
    if (typeof result === "number" && result > 0) {
      // 成功处理（使用ElMessageBox弹窗）
      resetForm();
      ElMessageBox.alert(
        locale.value == "zh"
          ? `亲爱的SIGGRAPH社区会员，感谢你注册2025年SIGGRAPH DAY的技术分享活动，我们已经收到你的报名信息，请留意你的邮箱，关注7月11日的活动详情。有任何疑问请联系secretariat@siggraph.cn`
          : `Dear SIGGRAPH community members, thank you for registering for the technical sharing event of 2025 SIGGRAPH DAY. We have received your registration information. Please keep an eye on your email and pay attention to the details of the event on July 11th. If you have any questions, please contact secretariat@siggraph.cn.`,
        {
          title: locale.value == "zh" ? "报名成功" : "Registration successful",
          confirmButtonText: locale.value == "zh" ? "确定" : "OK",
          type: "success",
          center: true,
          customClass: "success-message-box", // 添加自定义class便于样式调整
          callback: () => {
            // 关闭后的回调（可选）
            console.log("通知已关闭");
          },
        }
      );
    } else {
      ElMessageBox.alert(
        locale.value == "zh"
          ? `报名申请提交失败！`
          : `Registration application submission failed!`,
        {
          title:
            locale.value == "zh"
              ? result
                ? `${result}`
                : "未获取到有效返回结果"
              : result
              ? `${result}`
              : "No valid response received",
          confirmButtonText: locale.value == "zh" ? "确定" : "OK",
          type: "warning",
          center: true,
          customClass: "success-message-box", // 添加自定义class便于样式调整
          callback: () => {
            // 关闭后的回调（可选）
            console.log("通知已关闭");
          },
        }
      );
    }
  } catch (error) {
    ElMessage.error(
      locale.value == "zh"
        ? "提交失败，请稍后重试"
        : "Submission failed, please try again later"
    );
    console.error("API错误", error);
  } finally {
    isSubmitting = false;
  }

  // 异常处理（使用ElNotification通知）
  // ElNotification({
  //   title: locale.value == "zh" ? "提交异常" : "Submission Issue",
  //   message:
  //     locale.value == "zh"
  //       ? result
  //         ? `服务器返回异常代码：${result}`
  //         : "未获取到有效返回结果"
  //       : result
  //       ? `Server returned unexpected code: ${result}`
  //       : "No valid response received",
  //   type: "warning",
  //   duration: 3000, // 延长显示时间
  //   position: "bottom-right", // 改变位置避免遮挡弹窗
  //   offset: 50, // 偏移量
  //   showClose: true, // 显示关闭按钮
  // });

  //   } catch (error) {
  //     console.error("API请求错误:", error);

  //     // 错误处理逻辑
  //     let errorMessage =
  //       locale.value == "zh"
  //         ? "提交过程中发生错误"
  //         : "An error occurred during submission";

  //     if (error.response) {
  //       // 从错误响应中提取更多信息
  //       errorMessage =
  //         locale.value == "zh"
  //           ? `服务器错误 (${error.response.status})`
  //           : `Server error (${error.response.status})`;
  //     } else if (error.request) {
  //       errorMessage =
  //         locale.value == "zh"
  //           ? "网络连接异常，请检查网络"
  //           : "Network issue, please check your connection";
  //     }

  //     ElNotification({
  //       title: locale.value == "zh" ? "错误" : "Error",
  //       message: errorMessage,
  //       type: "error",
  //       duration: 2000,
  //       position: "center",
  //     });
  //   }
};
</script>

<style lang="scss">
.el-input__wrapper {
  height: 64px;
  box-sizing: border-box;
  padding: 20px 20px !important;
  border: 2px solid #777777 !important;
  border-radius: 8px !important;
  background-color: #d8ddf9;
}
.error {
  .el-input__wrapper {
    border: 2px solid #d43327 !important;
  }
}
</style>

<style lang="scss" scoped>
@import "@/sass/index.scss";
.content {
  position: relative;
  .thehome {
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    padding: 68px 0 0 0;
    text-align: left;
    margin-bottom: 80px;
  }
  .require {
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    text-align: right;
    @include fontstyle(#333, 16px, 800, auto);
    margin-bottom: 16px;
  }
  .inputcontent {
    background: #d7ddfa;
    padding: 82px 84px 0px 84px;
    z-index: 0;
    max-width: 1176px;
    margin: 0 auto;
    box-sizing: border-box;
  }
  .one {
    text-align: center;
    display: inline-block;
    @include fontstyle(#333, 40px, 800, auto);
    line-height: 47px;
    margin-bottom: 48px;
  }
  .member_table {
    max-width: 1176px;
    margin: 0 auto 56px;
    display: flex;
    flex-direction: column;
    .inputtype {
      @include fontstyle(#3657db, 22px, 800, auto);
      text-align: left;
      margin-bottom: 24px;
    }

    .submit {
      width: 232px;
      height: 106px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      :nth-child(2) {
        position: absolute;
        transition: all 0.5s;
        margin-bottom: 0px;
        left: 78px;
        opacity: 0;
        img {
          width: auto !important;
        }
      }
      &:hover {
        :nth-child(2) {
          left: 160px;
          opacity: 1;
        }
      }

      @include fontstyle(#fff, 20px, 800, auto);
      cursor: no-drop;
      line-height: 106px;
      position: relative;
      background: #ccc;
      right: -83px;
      align-self: flex-end;
      .tj {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .click {
      background: #3657db;
      cursor: pointer;
    }
    .row {
      display: flex;
      margin-bottom: 40px;
      align-items: center;

      .flex {
        flex: 1;
        text-align: left;
      }
      .toright {
        margin-right: 40px;
      }
    }

    .tothetitle {
      font-size: 18px;
      font-weight: 800;
      text-align: left;
      margin-bottom: 12px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .content {
    padding: 30px;
  }
}
@media screen and (max-width: 1000px) {
  .row {
    display: flex;
    flex-direction: column;
    .flex {
      width: 100%;
    }
    .toright {
      margin-right: 0px !important;
    }
    .tobottom {
      margin-bottom: 40px;
    }
  }
  .submit {
    width: 150px !important;
    height: 70px !important;

    .tj {
      font-size: 14px;
      line-height: 70px;
    }

    .arrow-icon {
      left: 50px;

      img {
        height: 14px;
      }
    }

    &:hover {
      .arrow-icon {
        left: 100px;
      }
    }
  }
}
@media screen and (max-width: 800px) {
  .inputcontent {
    padding: 82px 30px 0px 30px !important;
  }
  .submit {
    right: -30px !important;
  }
}
</style>
